var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.name,"left-arrow":"","fixed":true},on:{"click-left":function($event){return _vm.goback()}}}),_c('common-scrom',{attrs:{"id":+_vm.scrom.resId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }